import React, { useEffect, useState } from 'react';
const comparisonRows = [{
  without: '100+ horas/año planificando desde cero',
  with: '10 min/semana. El resto es atender.'
}, {
  without: 'Sesiones improvisadas → sin criterio clínico',
  with: '360+ páginas listas con objetivo y cierre'
}, {
  without: '60% de pacientes abandonan antes del año',
  with: 'Sistema de seguimiento → adherencia +75%'
}, {
  without: 'Sin progresión clínica clara',
  with: '6 tomos secuenciados → progresan y recomiendan'
}, {
  without: 'Cancelación = sesión perdida',
  with: 'Reglamento + contrato listos para usar'
}, {
  without: 'Informes que tardan horas',
  with: 'Reporte en 1 página en 5 min'
}, {
  without: 'Cobro irregular e incómodo',
  with: 'Abono blindado → cobro el día 1-5'
}, {
  without: 'Sin identidad profesional',
  with: 'Sistema que justifica cobrar 30-50% más'
}, {
  without: 'Sin scripts para pacientes',
  with: 'Scripts listos para WhatsApp y cierre de sesión'
}];
const TIMER_KEY = 'megapack_psi_countdown_end';
const DURATION_MS = 24 * 60 * 60 * 1000;
function getEndTime(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = localStorage.getItem(TIMER_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + DURATION_MS;
  localStorage.setItem(TIMER_KEY, String(end));
  return end;
}
function getTimeLeft(endTime: number) {
  const diff = Math.max(0, endTime - Date.now());
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(diff % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
}
export function DarkCTA() {
  const [endTime] = useState<number>(() => getEndTime());
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(endTime));
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft(endTime));
    }, 1000);
    return () => clearInterval(timer);
  }, [endTime]);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="w-full px-4 py-16 sm:py-20 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(245,243,255) 0%, rgb(245,243,255) 15%, rgb(245,243,255) 85%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-89">
      <div className="mx-auto max-w-4xl text-center" data-id="element-90">
        {/* Brand */}
        <div className="mb-8 sm:text-3xl font-black tracking-[3px] text-violet-700 text-[18px]" data-id="element-91">
          🧠 MEGAPACK PSICOLOGÍA RENTABLE™
        </div>

        {/* Headlines */}
        <h2 className="text-xl sm:text-3xl font-bold text-gray-900 m-0 mb-3" data-id="element-92">
          La próxima sesión podés volver a improvisar.
        </h2>
        <p className="text-xl sm:text-3xl font-black text-violet-700 m-0 mb-10" data-id="element-93">
          O podés entrar al lunes con todo resuelto desde hoy.
        </p>

        {/* Comparison Table */}
        <div className="mx-auto max-w-2xl mb-12 overflow-hidden rounded-2xl border border-gray-200 text-left" style={{
        backgroundColor: 'rgb(255, 255, 255)'
      }} data-id="element-94">
          <div className="text-center font-bold text-gray-900 border-b border-gray-200 px-4 py-4" style={{
          backgroundColor: 'rgb(243, 244, 246)'
        }} data-id="element-95">
            ¿Cuánto cuesta NO tenerlo?
          </div>

          <div className="grid grid-cols-2 border-b border-gray-200" style={{
          backgroundColor: 'rgb(243, 244, 246)'
        }} data-id="element-96">
            <div className="text-center font-bold text-gray-500 px-4 py-3 text-sm" data-id="element-97">
              SIN MEGAPACK
            </div>
            <div className="text-center font-bold text-violet-700 border-l border-gray-200 px-4 py-3 text-sm" data-id="element-98">
              CON MEGAPACK
            </div>
          </div>

          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-99">
              <div className="px-4 py-3 text-xs sm:text-sm text-gray-500" data-id="element-100">
                ✗ {row.without}
              </div>
              <div className="px-4 py-3 text-xs sm:text-sm font-bold text-gray-900 border-l border-gray-100" style={{
            backgroundColor: 'rgba(109, 40, 217, 0.05)'
          }} data-id="element-101">
                ✓ {row.with}
              </div>
            </div>)}
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-102">
          <p className="font-bold text-gray-900 m-0 mb-4" data-id="element-103">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-center justify-center gap-0" data-id="element-104">
            <div className="flex flex-col items-center" data-id="element-105">
              <span className="text-5xl sm:text-7xl font-black tabular-nums" style={{
              color: 'rgb(255, 68, 68)'
            }} data-id="element-106">
                {pad(timeLeft.hours)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-107">
                hs
              </span>
            </div>
            <span className="mb-4 text-5xl sm:text-7xl font-black" style={{
            color: 'rgb(255, 68, 68)'
          }} data-id="element-108">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-109">
              <span className="text-5xl sm:text-7xl font-black tabular-nums" style={{
              color: 'rgb(255, 68, 68)'
            }} data-id="element-110">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-111">
                min
              </span>
            </div>
            <span className="mb-4 text-5xl sm:text-7xl font-black" style={{
            color: 'rgb(255, 68, 68)'
          }} data-id="element-112">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-113">
              <span className="text-5xl sm:text-7xl font-black tabular-nums" style={{
              color: 'rgb(255, 68, 68)'
            }} data-id="element-114">
                {pad(timeLeft.seconds)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-115">
                seg
              </span>
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-600 m-0 mb-12" data-id="element-116">
          Después sube{' '}
          <span className="font-bold text-red-500" data-id="element-117">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* Two Pricing Cards */}
        <div className="mx-auto max-w-2xl mb-10 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-118">
          {/* Standard */}
          <div className="flex flex-col rounded-xl p-6 border border-gray-200 shadow-sm" style={{
          backgroundColor: 'rgb(255, 255, 255)'
        }} data-id="element-119">
            <div className="mb-2 text-2xl" data-id="element-120">🧠</div>
            <h3 className="text-base font-black text-gray-900 m-0 mb-1" data-id="element-121">
              MEGAPACK PSICOLOGÍA RENTABLE
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-122">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-123">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-124">
                Antes: $39.990 ARS
              </p>
              <p className="text-2xl font-black text-violet-700 m-0 mb-4" data-id="element-125">
                Hoy: $19.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48231331791018:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Megapack Psicología Rentable',
                  content_category: 'Psicología Rentable',
                  value: 19990,
                  currency: 'ARS'
                });
              }
            }} className="block text-white text-center text-sm font-black rounded-lg py-4 no-underline hover:opacity-90 transition-opacity" style={{
              backgroundColor: '#7c3aed'
            }} data-id="element-126">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          {/* Pro */}
          <div className="flex flex-col rounded-xl p-6 border-2 shadow-sm" style={{
          backgroundColor: 'rgb(245, 243, 255)',
          borderColor: '#7c3aed',
          boxShadow: 'rgba(124, 58, 237, 0.15) 0px 0px 30px 0px'
        }} data-id="element-127">
            <div className="mb-2 text-2xl" data-id="element-128">🏆</div>
            <h3 className="text-base font-black m-0 mb-1" style={{
            color: '#7c3aed'
          }} data-id="element-129">
              MEGAPACK + AUTORIDAD CLÍNICA™ ⭐
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-1" data-id="element-130">La más elegida</p>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-131">
              6 Tomos + 6 Bonos + Autoridad Clínica™
              <br data-id="element-132" />
              (cobro, encuadre, posicionamiento y negocio)
            </p>
            <div className="mt-auto" data-id="element-133">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-134">
                Antes: $54.990 ARS
              </p>
              <p className="text-3xl font-black m-0 mb-4" style={{
              color: '#7c3aed'
            }} data-id="element-135">
                Hoy: $27.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48231332380842:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Megapack + Autoridad Clínica',
                  content_category: 'Psicología Rentable',
                  value: 27990,
                  currency: 'ARS'
                });
              }
            }} className="block text-white text-center text-sm font-black rounded-lg py-4 no-underline hover:opacity-90 transition-opacity" style={{
              backgroundColor: '#7c3aed'
            }} data-id="element-136">
                → QUIERO EL MEGAPACK + AUTORIDAD CLÍNICA
              </a>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-600" data-id="element-137">
          <span data-id="element-138">🔒 Pago 100% seguro</span>
          <span data-id="element-139">⚡ Acceso en 5 minutos</span>
          <span data-id="element-140">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-141">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
      </div>
    </section>;
}